import { useState, useCallback } from "react";
import { addItem, removeItem } from "../../utils/array";

/**
 * A custom hook for state management of the checkbox group component.
 * It is consumed by the "Checkbox Group" component.
 *
 * @todo add more values for state including isInvalid, isRequired etc.
 */

export function useCheckboxGroup(props) {
  const { defaultValue, isDisabled, isInvalid } = props;
  // Default value can be a string or array, so this converts it to an ...
  // ... array so multiple values can be held.
  const [value, setValue] = useState(
    (typeof defaultValue === "string" ? defaultValue.split() : defaultValue) ||
      []
  );
  const handleChange = useCallback(
    (e) => {
      if (isDisabled) return;

      const isChecked = e.target.checked;

      const selectedValue = e.target.value;

      const changedValue = isChecked
        ? addItem(value, selectedValue)
        : removeItem(value, selectedValue);

      setValue(changedValue);
    },
    [isDisabled, value]
  );

  return {
    isDisabled,
    isInvalid,
    onChange: handleChange,
    value,
  };
}
